import { Component, Input } from "@angular/core";

@Component({
	selector: 'dms-column',
	template: `<div class="col-sm-12" ><ng-content></ng-content></div>`
})
export class ColumnComponent {
	
}